import styled from 'styled-components'
import { Fonts } from 'styles/constants';

export {
  ModalHeader,
  ModalContent,
  ModalBody,
  FormRow,
  FormActions,
  Button,
  ActivityIndicator,
} from 'styles/components';

export const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 0.1fr 0.35fr 1fr 0.1fr;
  width: 100%;
  gap: 2px;
  align-items: center;
`

export const Title = styled.h1`
  display: flex;
  align-items: center;
  height: 100%;
  font-family: ${Fonts.GilroySemiBold};
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SubTitle = styled.h2`
  height: 100%;
  align-content: center;
  font-family: ${Fonts.GilroyRegular};
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`